<template>
  <div class="system-dic-dialog-container">
    <el-dialog :title="title" :visible.sync="isShowDialog" width="969px">
      <el-form
        ref="dicDialogFormRef"
        :model="formData"
        v-loading="isLoading"
        :rules="rules"
        size="small"
        label-width="90px"
        class="demo-ruleForm"
      >
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="图片" prop="Picture">
              <el-upload
                style="width: 300px"
                class="avatar-uploader"
                :data="{ Type: 10 }"
                :action="uploadUrl"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-if="formData.Picture && isImage(formData.Picture)"
                  :src="formData.Picture"
                  class="avatar"
                />
                <video
                  v-else-if="formData.Picture && isVideo(formData.Picture)"
                  :src="formData.Picture"
                  class="avatar"
                />
                <i v-else class="center el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="排序序号">
              <el-input
                v-model="formData.bSort"
                type="number"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="描述" prop="">
              <el-input
                v-model="formData.bRemark"
                type=""
                placeholder="请输入字典描述"
                :rows="5"
                maxlength="150"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="onCancel" size="default">取 消</el-button>
          <el-button
            :loading="btnLoading"
            type="primary"
            @click="onSubmit"
            size="default"
            >保存</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import {
  QueryBlogDetail,
  UpdateBlogDetail,
  AddBlogDetail,
} from "@/api/ArticleContent/ArticleContent";
import { uploadFile } from "@/api/upload/upload";

export default {
  props: {
    uploadUrl: String,
  },
  data() {
    return {
      editor: null,
      key: "edit",
      title: "编辑",
      isShowDialog: false,
      isLoading: false,
      btnLoading: false,
      formData: {},
      rules: {
        Picture: [{ required: true, message: "请上传封面", trigger: "change" }],
      },
    };
  },
  computed: {},
  methods: {
    openDialog(e, key) {
      this.key = key;
      this.resetForm("");
      let dic = {
        edit: "编辑",
        add: "新增",
      };
      this.title = dic[key];
      key == "edit" && this.HttpQueryBlogDetail({ id: e.Id });
      key == "add" &&
        (this.formData = {
          Picture: "",
          btitle: "",
          bRemark: "",
          bcontent: "",
          bcategory: 10,
          bSort: 0,
        });
      this.isShowDialog = true;
    },
    resetForm(formName) {
      this.$refs.dicDialogFormRef && this.$refs.dicDialogFormRef.resetFields();
    },
    onCancel() {
      this.isShowDialog = false;
    },
    handleAvatarSuccess(res, file) {
      this.formData.Picture = res.response.Url;
      console.log(this.formData);
    },
    beforeAvatarUpload(file) {
      console.log("file1", file.type);
      if (file.type.includes("image")) {
        const isImage = file.type.includes("image");
        const isLt10M = file.size / 1024 / 1024 < 10;
        console.log("file2", file.type, isImage && isLt10M);
        // if (!isLt10M) {
        //   this.$message.error("上传图片大小不能超过 10MB!");
        // }
        // return isImage && isLt10M;
        return isImage;
      } else if (file.type.includes("video")) {
        const isVideo = file.type.includes("video");
        const isLt200M = file.size / 1024 / 1024 < 200;
        console.log(
          "file3",
          file.type,
          file.size,
          isVideo,
          isLt200M,
          isVideo && isLt200M
        );
        if (!isLt200M) {
          this.$message.error("上传视频大小不能超过200MB!");
        }
        return isVideo && isLt200M;
      } else {
        console.log("file4", file.type);
        this.$message.error("只能上传图片或者视频!");
        return false;
      }
      // const isImage = file.type.includes("image");
      // const isLt4M = file.size / 1024 / 1024 < 10;
      // if (!isImage) {
      //   this.$message.error("只能上传图片格式!");
      // }
      // if (!isLt4M) {
      //   this.$message.error("上传图片大小不能超过 10MB!");
      // }
      // console.log("file5", file.type, isImage && isLt4M);
      // return isImage && isLt4M;
    },
    isImage(urlStr) {
      const images = ["jpg", "jpeg", "png"];
      const lastIndex = urlStr.lastIndexOf(".");
      const substringFromEnd = urlStr.slice(lastIndex + 1);
      return images.includes(substringFromEnd);
    },
    isVideo(urlStr) {
      const videos = ["mp4", "avi"];
      const lastIndex = urlStr.lastIndexOf(".");
      const substringFromEnd = urlStr.slice(lastIndex + 1);
      return videos.includes(substringFromEnd);
    },
    onSubmit() {
      this.btnLoading = true;
      let that = this;
      this.$refs.dicDialogFormRef.validate((valid) => {
        this.btnLoading = false;
        if (valid) {
          that.submit();
        } else {
          console.log("error submit!!", valid);
          return false;
        }
      });
    },
    submit() {
      let param = this.formData;

      this.key == "add" && this.HttpAddBlogDetail(param);
      this.key == "edit" && this.HttpUpdateBlogDetail(param);
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
    },
    async HttpQueryBlogDetail(param) {
      this.isLoading = true;
      const response = await QueryBlogDetail(param);
      this.isLoading = false;
      let res = response.data;
      if (res.status == 200) {
        let raw = res.response || {};
        console.log("raw", raw);
        this.formData = raw;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async HttpUpdateBlogDetail(param) {
      this.btnLoading = true;
      const response = await UpdateBlogDetail(param);
      this.btnLoading = false;
      let res = response.data;
      if (res.status == 200) {
        this.isShowDialog = false;
        this.$emit("refresh");
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async HttpAddBlogDetail(param) {
      this.btnLoading = true;
      const response = await AddBlogDetail(param);
      this.btnLoading = false;
      let res = response.data;
      if (res.status == 200) {
        this.isShowDialog = false;
        this.$emit("refresh");
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
.center {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 300px !important;
  height: 178px;
  display: block;
}
</style>
